import { createSchedulingSettingsFormSchema } from './SchedulingSettingsForm.schema';
import type { SchedulingSettingsFormValues } from './SchedulingSettingsForm.schema';
import { getMessages } from './constants';
import { TFunction } from 'i18next';

// Validate form values
export const validateFormValues = (
  formValues: SchedulingSettingsFormValues,
  t: TFunction
): string | null => {
  const schedulingSettingsFormSchema = createSchedulingSettingsFormSchema(t);
  const result = schedulingSettingsFormSchema.safeParse(formValues);
  if (!result.success) {
    return result.error.errors[0].message;
  }
  return null;
};

// Confirm deletion with user
export const confirmDeletion = (): boolean => {
  return confirm(getMessages().CONFIRM.DELETE);
};
